import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../../models/work-item';
import { UIWorkFieldModel, UIPropertyModel } from 'e5core-angular-services';

@Component({
  selector: 'e5core-ui-work-field-bootstrap',
  templateUrl: './e5core-ui-work-field-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-bootstrap.component.css']
})
export class E5coreUiWorkFieldBootstrapComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input('field') field: UIWorkFieldModel ;
  @Input('property') property: UIPropertyModel ;
  @Input() readonly: boolean;

  constructor() { }

  ngOnInit() {
  }

}
